module.exports = __webpack_public_path__ + "media/src/images/icons/label_tag-3d1f239098aef6aa09e4bd351c0ee964.svg";